import React from "react";
import "./trackline.css";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import FeaturesOnServices from "./FeaturesOnServices";
import OurApproach from "./OurApproach";
import Technologies from "./Technologies";
import CallToAction from "./CallToAction";

const Trackline = () => {
  return (
    <>
      <Particles title="Trackline" />
      <HeroSection />
      <FeaturesOnServices />
      <OurApproach />
      <Technologies />
      <CallToAction />
    </>
  );
};

export default Trackline;
